import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-logo-placeholder',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './logo-placeholder.component.html',
    styleUrl: './logo-placeholder.component.scss',
})
export class LogoPlaceholderComponent {
    @Input() brand = '';
    @Input() isPortraitDevice = false;

    imageUrl: any;

    constructor() {}

    ngOnInit() {
        this.brand = this.brand;
        console.log(this.brand);
        console.log('./assets/img/themes/' + this.brand.toLowerCase() + '/bootstrapImg/brand.png');
    }
}
